import React, { useState } from "react"
import { CheckedEntry } from "../../../actions/incentiveList"
import { aggregateByTokeys, saveIncentiveList } from "../../../api/incentiveListApi"
import { notifications } from "@mantine/notifications"
import { Button } from "@mantine/core"
import { State } from "../../../reducers"
import { connect } from "react-redux"

interface OwnProps {
  clientId: number
  selectedTokeys: string[]
  // 生成（保存）成功後に呼ばれる。リスト一覧画面への遷移などに使う。
  onGenerated?: () => void
}

interface StateProps {
  entries: CheckedEntry[]
  csvFriendEmails: Record<string, string>
}

type Props = OwnProps & StateProps

// 特典付与対象者リスト生成ボタン
// selectedTokeysがあればそのCVだけで再集約して保存、なければ全エントリを保存する。
// Excelダウンロードは行わず、生成したリストはリスト一覧画面に積み上がる。
const IncentiveListGenerateButtonComponent: React.FC<Props> = ({
  clientId,
  selectedTokeys,
  onGenerated,
  entries,
  csvFriendEmails,
}) => {
  const [generating, setGenerating] = useState(false)

  const handleGenerate = async () => {
    setGenerating(true)
    try {
      // selectedTokeysがあればチェックされたCVだけで再集約（CSVフォールバックメールも渡す）、
      // なければ全エントリを対象にする。
      const source =
        selectedTokeys.length > 0
          ? (await aggregateByTokeys(clientId, selectedTokeys, csvFriendEmails)).entries
          : entries
      const payload = source.map((e) => ({
        name: e.name,
        email: e.email,
        role: e.role,
        count: e.count,
      }))

      if (payload.length === 0) {
        notifications.show({ message: '対象がありません', color: 'red' })
        return
      }

      await saveIncentiveList(clientId, payload)
      onGenerated?.()
    } catch (e) {
      console.error('特典付与リストの生成に失敗しました', e)
      notifications.show({ message: 'リストの生成に失敗しました', color: 'red' })
    } finally {
      setGenerating(false)
    }
  }

  const disabled =
    generating || (entries.length === 0 && selectedTokeys.length === 0)

  return (
    <Button
      variant="light"
      radius="xl"
      size="sm"
      onClick={handleGenerate}
      disabled={disabled}
      loading={generating}
    >
      リスト生成
    </Button>
  )
}

const mapStateToProps = (state: State): StateProps => ({
  entries: state.incentiveList.entries,
  csvFriendEmails: state.incentiveList.csvFriendEmails || {},
})

export const IncentiveListGenerateButton = connect(mapStateToProps)(
  IncentiveListGenerateButtonComponent as any,
) as any as React.ComponentType<OwnProps>
